import { render, staticRenderFns } from "./modalEditarImagenProducto.vue?vue&type=template&id=5b6c4efd"
import script from "./modalEditarImagenProducto.vue?vue&type=script&lang=js"
export * from "./modalEditarImagenProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports